"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserEmailVerifyCode = exports.UserEmailVerifyCodeType = void 0;
var UserEmailVerifyCodeType;
(function (UserEmailVerifyCodeType) {
    UserEmailVerifyCodeType["PasswordReset"] = "PASSWORD_RESET";
    UserEmailVerifyCodeType["PasswordInit"] = "PASSWORD_INIT";
})(UserEmailVerifyCodeType = exports.UserEmailVerifyCodeType || (exports.UserEmailVerifyCodeType = {}));
class UserEmailVerifyCode {
}
exports.UserEmailVerifyCode = UserEmailVerifyCode;
//# sourceMappingURL=userEmailVerifyCode.js.map